// extracted by mini-css-extract-plugin
module.exports = {"accordion":"FaqList-module__accordion___2qwou","blockContainer":"FaqList-module__blockContainer___2AM2H"};